import React from 'react';

import combinedActions from '~redux/combinedActions';
import { useAppDispatch, useAppSelector } from '~redux/hooks';

import SearchAndFilterBar, { TSearchAndFilterBarProps } from '~components/molecules/SearchAndFilterBar';

import * as Styles from './_productApprovalTableSearchAndFilterBar.module.scss';
import { MetalTypeEnum } from '~utils/enums';

const ProductApprovalTableSearchAndFilterBar = () => {
    const filters = useAppSelector(state => state.approval.pendingProductListing.filters);
    const productList = useAppSelector((state) => state.gold.allProducts);

    const dispatch = useAppDispatch();

    const setFilters = ({ productName, metalType }: { productName: string, metalType: MetalTypeEnum }) => dispatch(combinedActions.approvalSetPendingProductListingFilters({ productName, metalType }));
    const handleSearchClick = () => dispatch(combinedActions.approvalGetPendingProductListingAttempt());
    const handleCancelClick = () => {
        dispatch(combinedActions.approvalClearPendingProductListingFilters());
        dispatch(combinedActions.approvalGetPendingProductListingAttempt());
    };

    const massagedProductsListOption = () => {
        if (!productList.length) return [];
        return productList.map((product) => ({
            label: product.productName,
            value: product.productName,
        }));
    };

    const fields: TSearchAndFilterBarProps['fields'] = [
        {
            label: 'Product Name:',
            type: 'dropdown' as const,
            dropdownParams: {
                value: filters.productName || '',
                setValue: (event) => setFilters({ ...filters, productName: event.target.value }),
                options: massagedProductsListOption(),
                optionSelected: !!productList.find((product) => product.productName === filters.productName),
                noOptionsMessage: 'No product found',
                className: Styles.input,
            },
        },
        {
            label: 'Metal Type:',
            type: 'dropdown' as const,
            dropdownParams: {
                options: [
                    {
                        label: MetalTypeEnum[MetalTypeEnum.Gold],
                        value: MetalTypeEnum.Gold,
                    },
                    {
                        label: MetalTypeEnum[MetalTypeEnum.Silver],
                        value: MetalTypeEnum.Silver,
                    },
                ],
                value: MetalTypeEnum[filters.metalType as MetalTypeEnum],
                setValue: (event: React.ChangeEvent<HTMLInputElement>) => setFilters({
                    ...filters,
                    metalType: MetalTypeEnum[event.target.value as keyof typeof MetalTypeEnum],
                }),
                optionSelected: !!MetalTypeEnum[filters.metalType as MetalTypeEnum],
                noOptionsMessage: 'No metal type found',
            },
        },
    ];

    return (
        <SearchAndFilterBar
            fields={fields}
            searchOnClick={handleSearchClick}
            cancelOnClick={handleCancelClick}
            containerClassName={Styles['content-container']}
        />
    );
};

export default ProductApprovalTableSearchAndFilterBar;
